import { getLinkedItems } from '@/components/contexts/KontentHomeConfigProvider'
import type { IContentItemsContainer } from '@kontent-ai/delivery-sdk'
import type {
	PrescriptionContainer,
	PrescriptionGroup,
	PrescriptionOption,
	VariantBranch,
} from '../types'

const TYPE_PRESCRIPTION_GROUP = 'prescription_group'
const TYPE_PRESCRIPTION_OPTION = 'prescription_option'
const TYPE_PRESCRIPTION_STUDY = 'prescription_study'

type ContainerKind = VariantBranch['kind']

const classifyContainer = (
	container: PrescriptionContainer,
	linkedItems: IContentItemsContainer,
): ContainerKind | null => {
	if (container.system.type === TYPE_PRESCRIPTION_GROUP) {
		return 'standard'
	}

	if (container.system.type === TYPE_PRESCRIPTION_OPTION) {
		const inner =
			getLinkedItems(
				(container as PrescriptionOption).elements.prescriptions,
				linkedItems,
			) ?? []

		const firstInner = inner[0]
		if (!firstInner) return null

		if (firstInner.system.type === TYPE_PRESCRIPTION_GROUP) {
			return 'electives'
		}
		if (firstInner.system.type === TYPE_PRESCRIPTION_STUDY) {
			return 'author-study'
		}
	}

	return null
}

const makeBranch = (
	kind: ContainerKind,
	run: PrescriptionContainer[],
): VariantBranch => {
	if (kind === 'standard') {
		return { kind, containers: run as PrescriptionGroup[] }
	}
	return { kind, containers: run as PrescriptionOption[] }
}

export const dispatchVariant = (
	containers: PrescriptionContainer[],
	linkedItems: IContentItemsContainer,
): VariantBranch[] => {
	const branches: VariantBranch[] = []
	let currentKind: ContainerKind | null = null
	let currentRun: PrescriptionContainer[] = []

	const flushRun = (): void => {
		if (currentKind !== null && currentRun.length > 0) {
			branches.push(makeBranch(currentKind, currentRun))
		}
		currentKind = null
		currentRun = []
	}

	for (const container of containers) {
		const kind = classifyContainer(container, linkedItems)
		if (kind === null) {
			flushRun()
			continue
		}

		if (kind === currentKind) {
			currentRun.push(container)
		} else {
			flushRun()
			currentKind = kind
			currentRun = [container]
		}
	}

	flushRun()

	return branches
}
